export const enUsers = {
  title: "Users",
  subtitle: "View all users in your organization.",
  empty: "No users found.",
  actions: {
    newUser: "New User",
  },
  newUserModal: {
    title: "New User",
    closeAria: "Close dialog",
    fields: {
      email: "Email",
      fullName: "Full name",
    },
    validation: {
      required: "This field is required.",
      invalidEmail: "Enter a valid email address.",
    },
    actions: {
      cancel: "Cancel",
      addUser: "Add User",
    },
    errors: {
      saveFailed: "Failed to add user. Please try again.",
    },
  },
  table: {
    email: "Email",
    fullName: "Full name",
    actions: "Actions",
    ariaLabel: "Users",
  },
  missingFullName: "—",
  adminAccess: {
    grantAria: "Grant administrator access to {{email}}",
    revokeAria: "Revoke administrator access from {{email}}",
    grantDialog: {
      heading: "Grant administrator access?",
      subheading:
        "This user will be able to manage users, access, and all administrator settings.",
      cancel: "Cancel",
      confirm: "Grant Access",
    },
    revokeDialog: {
      heading: "Revoke administrator access?",
      subheading:
        "This user will immediately lose all administrator permissions.",
      cancel: "Cancel",
      confirm: "Revoke Access",
    },
    errors: {
      grantFailed: "Failed to grant access. Please try again.",
      revokeFailed: "Failed to revoke access. Please try again.",
    },
  },
  deleteDialog: {
    heading: "Are you sure you want to delete this user?",
    subheading:
      "Deleting this user will revoke all their permissions and access immediately.",
    cancel: "Cancel",
    confirm: "Delete",
    deleteAria: "Delete user {{email}}",
    errors: {
      deleteFailed: "Failed to delete user. Please try again.",
    },
  },
  learningInsights: {
    generateAria: "Regenerate Learning History for {{email}}",
    generateStarted: "Learning History regeneration started.",
  },
  profile: {
    title: "My Profile",
    subtitle: "View and update your account details.",
    fields: {
      fullName: "Full name",
      email: "Email",
    },
    validation: {
      nameRequired: "Full name is required.",
    },
    actions: {
      saveSucceeded: "Profile updated successfully.",
    },
    errors: {
      saveFailed: "Failed to update profile. Please try again.",
    },
  },
} as const;
